<template>
  <div>
    <MatchReport :obj="matchReport"/>
  </div>
</template>

<script>
import MatchReport from "@/components/league/MatchReport";

export default {
  data() {
    return {
      matchReport: {
        live: true,
        minute: 56,
        team1: {
          name: 'Britannia Schwetzingen',
          emblemId: '2_1599050281684'
        },
        team2: {
          name: 'FC Pink Oberschlesien',
          emblemId: '303_1595697117842'
        },
        goalsTeam1: 3,
        goalsTeam2: 1
      }
    }
  },
  components: {
    MatchReport
  }
}
</script>